import React from "react";
import "./SavedOpportunity.css";
import { useNavigate } from "react-router-dom";

export default function SavedOpportunity({ role }) {
    const navigate = useNavigate();

    // ✅ Role-aware base path
    const basePath = `/${role || "agent"}-dashboard`;

    return (
        <div className="saved-opportunity-card">
            <h3 className="card-title">Posts & Applications</h3>

            <div className="button-stack">
                {/* ✅ Uses RoleDashboard routes */}
                <button onClick={() => navigate(`${basePath}/view-posts`)}>
                    Posts
                </button>

                {/* ✅ FIXED: correct route path */}
                <button onClick={() => navigate(`${basePath}/view-applications`)}>
                    Applications
                </button>

                <button onClick={() => navigate(`${basePath}/bookmarks`)}>
                    Bookmarks
                </button>
            </div>
        </div>
    );
}

